export default [
  {  path: '/notfound',  component: () => import('./components/NotFound.vue')},
  {  path: '/home',  component: () => import('./components/page/home.vue')},

  // Дашборд — точка входа администратора. Путь '/' занят страницей входа
  // в routes/web.php, поэтому у главной страницы панели свой адрес.
  {  path: '/dashboard',  component: () => import('./components/page/DashboardPage.vue')},

  {  path: '/user',  component: () => import('./components/page/user/userPage.vue')},
  {  path: '/userprofile/:id', component: ()  => import('./components/page/user/profilePage.vue'),props: true},

  {  path: '/permission',  component: () => import('./components/page/permission/PermPage.vue')},

  // Добавление материала и библиотека контента.
  {  path: '/add',      component: () => import('./components/page/AddMaterialPage.vue')},
  {  path: '/content',  component: () => import('./components/page/ContentPage.vue')},
  {  path: '/stats',    component: () => import('./components/page/StatsPage.vue')},
  {  path: '/help',     component: () => import('./components/page/HelpPage.vue')},

  // Прежняя «Реклама» удалена: всё, что она умела, есть в «Добавить материал»,
  // «Контенте» и вкладке «Эфир» (включая порядок показа постеров).
  // Старый адрес ведёт в «Контент», чтобы закладки не упирались в пустоту.
  {  path: '/ad',  redirect: '/content'},

  // Рабочее место локации. Старая страница /pay остаётся доступной,
  // пока новая не повторит всё, что умела прежняя: панель боевая.
  {  path: '/locations',  component: () => import('./components/page/LocationsPage.vue')},
  {  path: '/locations/:id', component: () => import('./components/page/LocationWorkspace.vue'), props: true},

  {  path: '/pay',  component: () => import('./components/page/PayPage.vue')},
  {  path: '/pay/:id', component: ()  => import('./components/page/PayPage.vue'),props: true},


    ];